import { MAIN_QUESTS_GROUP } from "@/constants";
import { RuleId } from "@/domain/gems-game/domain/lib/LatestEarnings";
import { Quest as MainQuest } from "@/domain/gems-game/domain/lib/Quest";
import { EarningType } from "@/domain/gems-game/domain/lib/Quest";
import { QuestTileType } from "@/domain/gems-game/domain/lib/TileType";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

export const socialSharingTweetA =
  "@norma_metaland has officially landed on @Immutable! It's time to unleash your cooking frenzy and take your kitchen to the next level! Also, $GRAM(PUS) is coming to Immutable soon—stay tuned for more updates!";
export const socialSharingTweetB =
  "🔥🍳 I just put my cooking skills to the test in the World Chef Championship on @norma_metaland! 🍽️🔥 Think you can handle the heat? Jump in and start your own culinary adventure! 👨‍🍳👩‍🍳 #NormaInMetaland #WorldChefChampionship";
export const socialSharingTweetC =
  "🍫🔥 My Chocolate Pop-up Store is open in @norma_metaland! 🍽️✨ This game is an absolute treat 🍩🍪🍰 #NormaInMetaland";

export const normaInMetalandMainQuest1 = new MainQuest({
  id: RuleId.NORMAN_IN_METALAND,
  customTitle: [],
  customComingSoonTitle: [],
  caption: "Norma in Metaland caption",
  subtext: [],
  logo: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z4VHX5bqstJ99ZK3_NIM_Hero_17.webp?auto=format,compress",
  ),
  backgroundMediaUrl: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z33z1pbqstJ99J54_NIM_Slideshow_05.webp?auto=format,compress",
  ),
  gemsAmount: "50",
  analyticsId: "norma-in-metaland-quest",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OffChain,
  description: [],
  isGemDistributionPending: true,
  rules: {
    items: [
      "Status and points allocation will be updated weekly",
      "You must use your Immutable Passport account to qualify",
    ],
  },
  startDate: new Date("2025-03-31T02:00:00Z"),
  endDate: new Date("2025-05-11T01:00:00Z"),
  availableOn: ["iOS", "Android"],
});

export const normaInMetalandMainQuest2 = new MainQuest({
  id: RuleId.NORMAN_IN_METALAND,
  customTitle: [],
  customComingSoonTitle: [],
  caption: "Norma in Metaland caption",
  subtext: [],
  logo: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z4VHX5bqstJ99ZK3_NIM_Hero_17.webp?auto=format,compress",
  ),
  backgroundMediaUrl: new URL(
    "https://images.prismic.io/imtbl-player-portal/Z33z1pbqstJ99J54_NIM_Slideshow_05.webp?auto=format,compress",
  ),
  gemsAmount: "50",
  analyticsId: "norma-in-metaland-quest",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OffChain,
  description: [],
  isGemDistributionPending: true,
  rules: {
    items: [
      "Status and points allocation will be updated weekly",
      "You must use your Immutable Passport account to qualify",
    ],
  },
  startDate: new Date("2025-03-31T02:00:00Z"),
  endDate: new Date("2025-05-11T01:00:00Z"),
  availableOn: ["iOS", "Android"],
});

const normaInMetalandQuestsListConnect: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow on Immutable Play",
    caption: "Get exclusive content",
    increase: 15,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-wishlist-added",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-wishlist",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join GRAM Community on Discord",
    caption: "Join our massively growing community",
    linkUrl: "https://discord.com/invite/gramecosystem",
    increase: 15,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-discord-followed",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-discord",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow @gram_voyage on X",
    caption: "Don't miss a tweet",
    linkUrl: "https://x.com/gram_voyage",
    increase: 15,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-twitter-1-followed",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-twitter-1",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow @norma_metaland on X",
    caption: "Don't miss a tweet",
    linkUrl: "https://x.com/norma_metaland",
    increase: 15,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-twitter-2-followed",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-twitter-2",
  },
  {
    type: "link",
    key: "x-post-tweet-validation",
    icon: "X",
    label: "Post on X about playing Norma in Metaland",
    caption: "Extra Gems for sharing on X",
    linkUrl: `https://twitter.com/intent/tweet?text=${encodeURIComponent(socialSharingTweetA)}`,
    increase: 40,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-x-sharing-1-event",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-x-sharing-1",
    startTime: new Date("2025-03-30T02:00:00Z"),
    tweetText: socialSharingTweetA,
  },
];

const normaInMetalandQuestsListPlay: Quest[] = [
  {
    type: "custom",
    key: "daily-game-play",
    icon: "PlayGame",
    label: "Play the game daily",
    caption: "",
    increase: 25,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-passport-checkin-completed",
    ruleId: "passport-checkin",
    recurring: true,
    endDate: new Date("2025-05-12T00:00:00Z"),
  },
  {
    type: "custom",
    key: "in-game",
    icon: "TreasureChest",
    label: "Reach Chef level 5",
    caption: "Learn how to earn more points",
    increase: 50,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-main-quest-1-event",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-main-quest-1",
    ruleModal: normaInMetalandMainQuest1,
  },
  {
    type: "custom",
    key: "in-game",
    icon: "TreasureChest",
    label: "Donut House Level Completion",
    caption: "Learn how to earn more points",
    increase: 50,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-main-quest-2-event",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-main-quest-2",
    ruleModal: normaInMetalandMainQuest2,
  },
  {
    type: "link",
    key: "x-post-tweet-validation",
    icon: "X",
    label: "Post on X about the World Chef Championship",
    caption: "Extra Gems for sharing on X",
    linkUrl: `https://twitter.com/intent/tweet?text=${encodeURIComponent(socialSharingTweetB)}`,
    increase: 20,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-x-sharing-2-event",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-x-sharing-2",
    startTime: new Date("2025-03-30T02:00:00Z"),
    tweetText: socialSharingTweetB,
  },
  // {
  //   type: "link",
  //   key: "x-share-validation",
  //   icon: "X",
  //   label: "Post on X about the Chocolate Pop-up Store",
  //   caption: "Extra Gems for sharing on X",
  //   linkUrl: `https://twitter.com/intent/tweet?text=${encodeURIComponent(socialSharingTweetC)}`,
  //   increase: 20,
  //   badgeIcon: "Sparkle",
  //   badgeTemplate: "+<increase> <icon>",
  //   eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-x-sharing-3-event",
  //   ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-x-sharing-3",
  // },
];

const normaInMetalandQuestsListOwn: Quest[] = [
  {
    type: "custom",
    key: "ownership",
    icon: "Coins",
    label: "Hold Immutable Burger Truck NFT",
    caption: "100 points for holding Immutable Burger Truck NFT.",
    increase: 100,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-asset-ownership-1-event",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-asset-ownership-1",
    assetHoldingType: "erc1155",
    assetHoldingToken: {
      name: "IMX Burger Truck",
      image: "https://immutableburgertruck.nft.grampus.co/images/BurgerNFT.png",
      // Norma real collection
      collectionAddress: "0x26DE09CF49C258fFd8D7B4c5acCfE1F9e578C71B",
      pointsMultiplier: 100,
      minimumBalance: 1,
      tokenId: "1",
      purchaseUrl:
        "https://tokentrove.com/collection/NormaInMetalandImmutableBurgerTrucks",
      // isEarlyAdopterReward: true,
    },
  },
  {
    type: "custom",
    key: "ownership",
    icon: "Coins",
    label: "Hold Norma in Metaland NFTs",
    caption:
      "5 points per asset for holding Norma in Metaland NFTs, max 100 points.",
    increase: 100,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<progressPoints> / <increase> <icon>",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-asset-ownership-2-event",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-asset-ownership-2",
    assetHoldingType: "erc721",
    assetHoldingToken: {
      name: "Norma in Metaland Official",
      image: "https://normaland.nft.grampus.co/images/0021.png",
      // Norma real collection
      collectionAddress: "0x03ded184a7c4cb7a8224c544843cF52ae986cB1a",
      minimumBalance: 1,
      pointsMultiplier: 5,
      purchaseUrl: "https://tokentrove.com/collection/NormaInMetalandOfficial",
    },
  },
  {
    type: "custom",
    key: "ownership",
    icon: "Coins",
    label: "Hold $CANDY",
    caption: "100 points for holding $CANDY, 1 point per 10 $CANDY.",
    increase: 100,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<progressPoints> / <increase> <icon>",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-asset-ownership-3-event",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-asset-ownership-3",
    assetHoldingType: "erc20",
    assetHoldingToken: {
      name: "CANDY",
      image:
        "https://d3u2pnu58u70ht.cloudfront.net/Announcement/candy_icon%20(2).png",
      collectionAddress: "0x774abacb13b4f3b68132a9995077aba9b7df8d32",
      minimumBalance: 1,
      pointsMultiplier: 0.1,
      purchaseUrl: "https://gram-voyage.medium.com/norma-is-back-8b1daf420c74",
    },
  },
];

export const normaInMetalandQuestsPoints: QuestGroup[] = [
  {
    key: "connect",
    header: {
      image: "",
      description: "",
      title: "Connect",
    },
    totalGemsGranted: 0,
    quests: normaInMetalandQuestsListConnect,
    questGroup: MAIN_QUESTS_GROUP,
  },
  {
    key: "play",
    header: {
      image: "",
      description: "",
      title: "Play",
    },
    totalGemsGranted: 0,
    quests: normaInMetalandQuestsListPlay,
    questGroup: MAIN_QUESTS_GROUP,
  },
  {
    key: "own",
    header: {
      image: "",
      description: "",
      title: "Own",
    },
    totalGemsGranted: 0,
    quests: normaInMetalandQuestsListOwn,
    questGroup: MAIN_QUESTS_GROUP,
  },
];
